/**
 * Sorts lancés au toucher (mobile) : un appui sur une case de la barre de sorts arme le sort pour le prochain pas
 * de simulation, consommé une seule fois par la source d'entrée (équivalent tactile des touches 1 à 4).
 */
const queued = [false, false, false, false];

export function queueTouchSpell(i: number): void { if (i >= 0 && i < queued.length) queued[i] = true; }

export function consumeTouchSpell(i: number): boolean { const q = queued[i] ?? false; queued[i] = false; return q; }

export function clearTouchSpells(): void { queued.fill(false); }
